import { render, staticRenderFns } from "./AddCamera.vue?vue&type=template&id=0025346c&scoped=true&"
import script from "./AddCamera.vue?vue&type=script&lang=js&"
export * from "./AddCamera.vue?vue&type=script&lang=js&"
import style0 from "./AddCamera.vue?vue&type=style&index=0&id=0025346c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025346c",
  null
  
)

export default component.exports